/**
 * Powers fields backed by the ListView interface
 *
 * TODO(mattjs) Elided mode support
 *
 * @author (MattJS) matt@yext.com
 */
goog.provide('yext.location.List');
goog.provide('yext.location.ListModel');
goog.provide('yext.location.ListItem');

goog.require('yext');
goog.require('yext.location.helpers');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');

/**
 * This model mirrors ListView Java class
 *
 * @param {!Object} data Plain version of ListModel
 * @constructor
 */
yext.location.ListModel = function(data) {
  this.orderVaries = false;
  this.displayOrderVaries = false;
  this.indeterminate = false;
  this.displayIndeterminate = false;
  this.numElided = 0;
  this.numDisplayElided = 0;
  this.isBulkEditMode = !!data.isBulkEditMode;
  this.timestamp = undefined;

  this.values = [];
  this.displayValues = [];

  if (data) {
    this.set(data);
  }
};

/**
 * Set values on the list model, checking for changes
 *
 * @param {!Object} data Plain version of ListModel
 * @return {boolean} True if the update changes the model
 */
yext.location.ListModel.prototype.set = function(data) {
  var changed = false;
  if (yext.isBoolean(data.orderVaries) && data.orderVaries != this.orderVaries) {
    changed = true;
    this.orderVaries = data.orderVaries;
  }
  if (yext.isBoolean(data.displayOrderVaries) && data.displayOrderVaries != this.displayOrderVaries) {
    changed = true;
    this.displayOrderVaries = data.displayOrderVaries;
  }
  if (yext.isBoolean(data.indeterminate) && data.indeterminate != this.indeterminate) {
    changed = true;
    this.indeterminate = data.indeterminate;
  }
  if (yext.isBoolean(data.displayIndeterminate) && data.displayIndeterminate != this.displayIndeterminate) {
    changed = true;
    this.displayIndeterminate = data.displayIndeterminate;
  }
  if (yext.isNumber(data.numElided) && data.numElided != this.numElided) {
    changed = true;
    this.numElided = data.numElided;
  }
  if (yext.isNumber(data.numDisplayElided) && data.numDisplayElided != this.numDisplayElided) {
    changed = true;
    this.numDisplayElided = data.numDisplayElided;
  }
  if (Array.isArray(data.values) && this.checkListItems(data.values, this.values)) {
    this.values = data.values;
    changed = true;
  }
  if (Array.isArray(data.displayValues) && this.checkListItems(data.displayValues, this.displayValues)) {
    this.displayValues = data.displayValues;
    changed = true;
  }
  // Timestamps are strings because they overflow javascript's max number size
  if (yext.isString(data.timestamp) && data.timestamp != this.timestamp) {
    this.timestamp = data.timestamp;
    changed = true;
  }
  if (!this.values.length) {
    this.orderVaries = false;
  }
  if (!this.displayValues.length) {
    this.displayOrderVaries = false;
  }
  return changed;
};

/**
 * @param {yext.location.ListItem} item List item to be added to the values list
 */
yext.location.ListModel.prototype.addItem = function(item) {
  this.checkItemType(item);
  this.values.push(item);
  this.message('updated');
};

/**
 * Calls set and optionally triggers an update message
 *
 * @param {!Object} data Plain version of ListModel
 */
yext.location.ListModel.prototype.update = function(data) {
  if (this.set(data)) {
    this.message('updated');
  }
};

/**
 * Make a copy of the object
 *
 * @return {yext.location.ListModel}
 */
yext.location.ListModel.prototype.copy = function() {
  return new yext.location.ListModel({
    orderVaries: this.orderVaries,
    displayOrderVaries: this.displayOrderVaries,
    indeterminate: this.indeterminate,
    displayIndeterminate: this.displayIndeterminate,
    numElided: this.numElided,
    numDisplayElided: this.numDisplayElided,
    values: this.copyValues(this.values),
    displayValues: this.copyValues(this.values),
  });
};

/**
 * Make a copy of a list of values
 * @param {!Array.<yext.location.ListItem>}
 * @return {!Array.<yext.location.ListItem>}
 */
yext.location.ListModel.prototype.copyValues = function(values) {
  var copy = [];
  values.forEach(function(value) {
    copy.push(value.copy());
  });
  return copy;
};

/**
 * Typechecks list of ListItems and checks for changes with the current list
 *
 * @param {!Array.<yext.location.ListItem>} newValues Update list items
 * @param {!Array.<yext.location.ListItem>} originalValues Original list items
 * @return {boolean} True if the update will change the model
 */
yext.location.ListModel.prototype.checkListItems = function(newValues, originalValues) {
  var changed = newValues.length !== originalValues.length;
  for (var i = 0; i < newValues.length; i++) {
    this.checkItemType(newValues[i]);
    if (originalValues.length > i && originalValues[i] != newValues[i]) {
      changed = true;
    }
  }
  return changed;
};

/**
 * Typechecks a yext.location.ListItem
 *
 * @param {yext.location.ListItem} item List item to be checked
 */
yext.location.ListModel.prototype.checkItemType = function(item) {
  if (!(item instanceof yext.location.ListItem)) {
    throw new TypeError('Items must be of class yext.location.ListItem');
  }
};

/**
 * Make updates to a particular list item
 *
 * @param {yext.location.ListItem} item List item to be updated
 * @param {!Object} data A plain version of ListItem
 */
yext.location.ListModel.prototype.updateItem = function(item, data) {
  if (item.update(data)) {
    this.message('updated');
  }
};

/**
 * Remove an item from this list
 */
yext.location.ListModel.prototype.removeItem = function(item) {
  var index = this.values.indexOf(item);
  if (index > -1) {
    this.values.splice(index, 1);
    this.message('updated');
  }
};

/**
 * Remove all elided items
 */
yext.location.ListModel.prototype.removeAllElided = function() {
  this.numElided = 0;
  this.message('updated');
};

/**
 * Triggers a message with the model as context
 *
 * @param {string} message The message to be triggered
 */
yext.location.ListModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Mirrors ListView.ListItem Java class
 *
 * @param {!Object} data Plain version of ListItem
 * @constructor
 */
yext.location.ListItem = function(data) {
  this.value = '';
  this.assetId = '';
  this.indeterminate = false;

  if (data) {
    this.update(data);
  }
};

/**
 * Makes updates and checks for changes to the list item
 *
 * @param {!Object} data Plain version of ListItem
 */
yext.location.ListItem.prototype.update = function(data) {
  var updated = false;
  if (this.value !== data.value && data.value !== undefined) {
    this.value = data.value;
    updated = true;
  }
  if (yext.isBoolean(data.indeterminate)) {
    this.indeterminate = data.indeterminate;
    updated = true;
  }
  if (this.assetId != data.assetId && data.assetId !== undefined) {
    this.assetId = data.assetId;
    updated = true;
  }
  return updated;
};

/**
 * Make a copy of the object
 *
 * @return {yext.location.ListItem}
 */
yext.location.ListItem.prototype.copy = function() {
  return new yext.location.ListItem({
    value: this.value,
    indeterminate: this.indeterminate,
    assetId: this.assetId,
  });
};

/**
 * This object is the view model for fields that implement the ListView Java interface
 *
 * @param {!jQuery} $ctx Context for finding field elements
 * @constructor
 */
yext.location.List = function($ctx) {
  this.$ctx = $ctx;
  this.$list = $ctx.find('.js-list-field');
  this.$display = $ctx.find('.js-list-field-display');
  this.$itemTemplate = $($ctx.find('.js-list-item-template').html());
  this.fieldName = $ctx.find('.js-field-data').data('fieldName');
  this.fieldId = $ctx.find('.js-field-data').data('fieldId');
  this.isAssetsOnly = $ctx.find('.js-field-data').data('assetsOnly');

  this.model = this.parseList();
  this.maxItemCount = this.$list.data('maxItemCount');

  this.storeValue();
  this.bindReorder();
  this.bindAddItem();
  this.bindRemoveItem();
  this.bindUpdates();
  this.bindAsset();
  this.setHiddenInputValue();
};

/**
 * Parse the initial state from the DOM
 *
 * @return {yext.location.ListModel} Model for the field
 */
yext.location.List.prototype.parseList = function() {
  var self = this;
  var data = {
    values: [],
    displayValues: [],
  };
  // Fetch by attribute value on purpose to avoid trimming of large number
  var timestamp = this.$ctx.attr('data-timestamp');

  // Ensure the value is not empty or 'null'
  if (/^\d+$/.test(timestamp)) {
    data.timestamp = timestamp;
  }

  data.orderVaries = this.$list.data('orderVaries');
  data.numElided = this.$list.data('numElided');

  this.$list.find('.js-string-list-item').each(function() {
    var $this = $(this);
    var $checkbox = $this.find('input[type=checkbox]');
    var $textinput = $this.find('input[type=text]');

    var item = new yext.location.ListItem({
      value: $textinput.val(),
      indeterminate: !!$checkbox.data('indeterminate'),
    });

    if (item.indeterminate) {
      $checkbox.prop('indeterminate', true);
      data.indeterminate = true;
    }

    data.values.push(item);
    self.bindItem($this, item);
  });

  if (this.$display.length) {
    var $displayList = this.$display.find('ul');

    if ($displayList.length) {
      $displayList.find('.js-string-list-item').each(function() {
        data.displayValues.push(new yext.location.ListItem({
          value: $(this).text(),
        }));
      });
    }

    data.displayOrderVaries = this.$display.data('displayOrderVaries');
    data.numDisplayElided = this.$display.data('numDisplayElided');
    data.displayIndeterminate = this.$display.data('displayIndeterminate');
  }

  return new yext.location.ListModel(data);
};

/**
 * @return {boolean} isEmpty
 */
yext.location.List.prototype.isEmpty = function() {
  return this.model.values.length === 0;
};

/**
 * @return {boolean} isElidedMode
 */
yext.location.List.prototype.isElidedMode = function() {
  return this.model.numElided > 0;
};

/**
 * Add an empty item to the list
 */
yext.location.List.prototype.addEmptyItem = function() {
  var $li = this.$itemTemplate.clone();
  var item = new yext.location.ListItem();
  this.bindItem($li, item);
  this.$list.append($li);
  this.model.addItem(item);
  $li.find('input[type=text]').focus();
};

/**
 * Bind clicks on the asset selector buttons to open the asset selector and apply the selected
 * asset id and value to the model.
 */
yext.location.List.prototype.bindAsset = function() {
  const selectorUsage = goog.module.get('yext.dam.assetselector.usage');
  const self = this;

  if (this.isAssetsOnly) {
    this.$ctx.find('input').prop('readonly', true);
  }

  this.$ctx.find('.js-choose-text-asset').each(function(i) {
    // Because we rebind assets on every item add, remove old click handlers so
    // only 1 is bound at a time.
    let $menu = $(this).siblings('.js-asset-container').find('.js-asset-actions-dropdown');
    let $applyAsset = $menu.find('.js-apply-asset');
    let $clearField = $menu.find('.js-clear-field');
    $(this).off('click');
    $applyAsset.off('click');
    $clearField.off('click');

    $(this).on('click', e => {
      if (!$menu.is(':visible')) {
        $('.js-asset-actions-dropdown').hide();
        $menu.show();
        e.stopPropagation();
      }
    });

    $applyAsset.on('click', () => {
      yext.dam.assetselector.events.show({
        type: yext.dam.assetselector.types.TEXT,
        includeUsedAssets: false,
        usageType: selectorUsage.forProfileFields(self.fieldId),
      },
      self.fieldName);

      $(yext.dam.assetselector.events).on('added.assetselector', (e, asset) => {
        if (asset.type === 'Text') {
          self.model.values[i].update(
            {
              'value': asset.data,
              'assetId': asset.id,
            });
          $(self.model).trigger('updated');
        }
      });
    });

    $clearField.on('click', () => {
      self.model.values[i].update(
        {
          'value': '',
          'assetId': '',
        });
      $(self.model).trigger('updated');
    });

    $(document).click(function() {
      $menu.hide();
    });
  });
};

/**
 * Bind the view to the model and store the model on the DOM
 *
 * @param {!jQuery} $li Element representing a list value
 * @param {yext.location.ListItem} item List item being bound
 */
yext.location.List.prototype.bindItem = function($li, item) {
  var self = this;
  var $checkbox = $li.find('input[type=checkbox]');
  var $textinput = $li.find('input[type=text]');
  $li.data('listItem', item);
  $checkbox.on('click', function() {
    // Force indeterminate -> determinate to leave checked as true
    if (item.indeterminate) {
      $checkbox.prop('checked', true);
    }
    self.model.updateItem(item, {
      indeterminate: false,
    });
  });
  $textinput.change(function() {
    self.model.updateItem(item, {
      value: $textinput.val(),
      indeterminate: false,
      assetId: '',
    });
  });
};

/**
 * Bind reorder function
 */
yext.location.List.prototype.bindReorder = function() {
  var self = this;
  this.$list.sortable({
    handle: '.js-reorder-item',
    axis: 'y',
    stop: function(e, ui) {
      self.reordered();
      // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
      // image to be misaligned the next time it gets dragged. Explicitly
      // set top/left to auto to fix this.
      ui.item
        .css('top', 'auto')
        .css('left', 'auto');
    },
    containment: this.$list,
    tolerance: 'pointer',
  });
};

/**
 * Bind add item interaction
 */
yext.location.List.prototype.bindAddItem = function() {
  var self = this;

  this.$ctx.find('.js-add-item').on('click', function() {
    self.addEmptyItem();
    self.bindAsset();
  });
};

/**
 * Bind remove item interaction and remove elided items interaction
 */
yext.location.List.prototype.bindRemoveItem = function() {
  var self = this;

  this.$list.on('click', '.js-remove-item', function() {
    var $li = $(this).closest('.js-string-list-item');
    self.model.removeItem($li.data('listItem'));
    $li.remove();
  });

  this.$ctx.find('.js-remove-elided-items').on('click', function() {
    self.model.removeAllElided();
  });
};

/**
 * Syncs the order of the DOM with the order in the model
 */
yext.location.List.prototype.reordered = function() {
  var values = [];
  this.$list.find('.js-string-list-item').each(function() {
    values.push($(this).data('listItem'));
  });
  this.model.update({
    values: values,
    orderVaries: false,
  });
};

/**
 * Listen for updates from the model and propagate them with the context of
 * the view model and renders the field
 */
yext.location.List.prototype.bindUpdates = function() {
  var self = this;

  $(this.model).on('updated', function() {
    self.render();
    self.message('updated');
    self.setHiddenInputValue();
  });
};

/**
 * Renders the field after it has been updated. Allows for a partial re-render
 * as not to disturb focus
 */
yext.location.List.prototype.render = function() {
  var items = this.$list.find('.js-string-list-item').toArray();

  for (var i = 0; i < this.model.values.length; i++) {
    var $item = items[i] ? $(items[i]) : false;
    var model = this.model.values[i];
    if ($item
        && $item.data('listItem') == model) {
      // Found the item in place, render it
      this.renderItem($item);
    } else {
      // Re-template and remove the item in this place
      var $newItem = this.$itemTemplate.clone();
      if ($item) {
        $newItem.insertAfter($item);
        $item.remove();
      } else {
        this.$list.append($newItem);
      }
      this.bindItem($newItem, model);
      this.renderItem($newItem);
    }
  }
  // Remove extra elements at the end
  for (var i = this.model.values.length; i < items.length; i++) {
    $(items[i]).remove();
  }

  // Don't allow more then max items to be added
  var underMax = this.model.values.length < this.maxItemCount;
  this.$ctx.find('.js-add-item').toggle(underMax);
  this.$ctx.find('.js-max-item-message').toggle(!underMax);

  // Toggle order varies message
  this.$ctx.find('.js-order-varies-message').toggle(this.model.orderVaries);

  // Toggle and update elided items count message
  var elidedMessage = yext.msgn('1 item', '{0} items', this.model.numElided);
  this.$ctx.find('.js-elided-message').text(elidedMessage);
  this.$ctx.find('.js-elided-mode-wrap').toggle(this.isElidedMode());
  this.bindAsset();
};

/**
 * Render an list item with its current model values
 *
 * @param {!jQuery} $item The list item element
 */
yext.location.List.prototype.renderItem = function($item) {
  var $input = $item.find('input[type=text]');
  var $checkbox = $item.find('input[type=checkbox]');
  var model = $item.data('listItem');

  if ($input.val() != model.value) {
    $input.val(model.value);
  }
  $checkbox.prop('indeterminate', model.indeterminate);
};

/**
 * Broadcasts a message with the instance as context
 */
yext.location.List.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Returns the display value as an HTML string for the field
 *
 * @return {string}
 */
yext.location.List.prototype.getDisplayValue = function() {
  if (this.model.displayIndeterminate) {
    return yext.location.helpers.variousContentMessage();
  }

  if (this.model.displayValues.length === 0 && !this.isElidedMode()) {
    return yext.location.helpers.emptyFieldMessage();
  }

  var values = this.model.displayValues.map(function(item) {
    return yext.location.helpers.escapeInput(item.value);
  });

  var result = '';

  if (this.model.displayOrderVaries) {
    // TRANSLATORS: The order across multiple lists varies
    result += '&lt;' + yext.msg('Order varies') + '&gt';
  }

  result += '<ul><li tid="string-list-item-display">' +
    values.join('</li><li tid="string-list-item-display">') + '</li></ul>';

  if (this.isElidedMode()) {
    if (this.model.displayValues.length === 0) {
      result += yext.msgn('1 item', '{0} items', this.model.numDisplayElided);
    } else {
      result += yext.msgn('...and 1 additional item', '...and {0} additional items',
        this.model.numDisplayElided);
    }
  }

  return result;
};

/**
 * Get the field represented as a JSON string
 */
yext.location.List.prototype.get = function() {
  var values = [];
  this.$list.find('.js-string-list-item').each(function() {
    var $this = $(this);
    var $checkbox = $this.find('input[type=checkbox]');
    if ($checkbox.length === 0 || $checkbox.prop('checked')) {
      var item = $this.data('listItem');
      if (item.value) {
        values.push(item);
      }
    }
  });

  return yext.JSON.stringify({
    'values': values,
    'numElided': this.model.numElided,
    'timestamp': this.model.timestamp,
    'orderVaries': this.model.orderVaries,
  });
};

/**
 * Store a copy of the model
 */
yext.location.List.prototype.storeValue = function() {
  this.storedModel = this.model.copy();
};

/**
 * Reset the model to a stored state
 */
yext.location.List.prototype.reset = function() {
  this.$list.empty();
  this.model.update(this.storedModel.copy());
  this.render();
};

/**
 * Reset the model to a stored state
 */
yext.location.List.prototype.set = function(field) {
  var values = [];
  var displayValues = [];

  field.values = field.values.map(function(item) {
    return new yext.location.ListItem(item);
  });

  field.displayValues = field.displayValues.map(function(item) {
    return new yext.location.ListItem(item);
  });

  this.$list.empty();
  this.model.update(field);
  this.render();
};

/**
 * Sets the hidden input with the fields name to the JSON string
 * value of the field
 */
yext.location.List.prototype.setHiddenInputValue = function() {
  this.$ctx.find('.js-field-value-json').val(this.get());
};
